import { render, staticRenderFns } from "./editAttributeGroup.vue?vue&type=template&id=5e0741b6&scoped=true"
import script from "./editAttributeGroup.vue?vue&type=script&lang=js"
export * from "./editAttributeGroup.vue?vue&type=script&lang=js"
import style0 from "./editAttributeGroup.vue?vue&type=style&index=0&id=5e0741b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0741b6",
  null
  
)

export default component.exports